import { render, staticRenderFns } from "./TvDetail.vue?vue&type=template&id=5cca0df0&scoped=true"
import script from "./TvDetail.vue?vue&type=script&lang=js"
export * from "./TvDetail.vue?vue&type=script&lang=js"
import style0 from "./TvDetail.vue?vue&type=style&index=0&id=5cca0df0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cca0df0",
  null
  
)

export default component.exports